module.exports = {"350404001":"列东街道","350404002":"列西街道","350404003":"徐碧街道","350404004":"城关街道","350404005":"白沙街道","350404006":"富兴堡街道","350404007":"荆西街道","350404100":"陈大镇","350404101":"洋溪镇","350404102":"莘口镇","350404103":"岩前镇","350404200":"中村乡","350404500":"福建三元经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350404.json
// module id = 1296
// module chunks = 0